// @ts-nocheck
import React from "react";

import { Global } from "@emotion/react";

import * as styles from "./GlobalStyles.styles";


function GlobalStyles() {
  return (
    <>
      <Global styles={styles.dimmer} />
      <Global styles={styles.popup} />
      <Global styles={styles.placeholder} />
      <Global styles={styles.checkbox} />
    </>
  );
}



export default GlobalStyles;
